export default "__VITE_ASSET__8jh5xtLE__"